/* eslint-disable jsx-a11y/no-noninteractive-element-interactions,
react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../../../Abstrap/Abstrap';

import eyeVisible from '../../../../../../../../styles/yurstrap/app/images/eye-visible.svg';
import eyeHidden from '../../../../../../../../styles/yurstrap/app/images/eye-hidden.svg';

const propTypes = {
    ...commonPropTypes,
    visible: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};

const defaultProps = {
    ...commonDefaultProps,
    visible: false,
};

const PasswordSymbol = (props) => {
    const classNames = [
        'c-form-field--icon',
        'js-symbol-password',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            <img
                className={props.visible
                    ? 'visible'
                    : ''}
                src={props.visible ? eyeVisible : eyeHidden}
                alt={props.visible
                    ? 'Cacher le mot de passe'
                    : 'Afficher le mot de passe'}
                onClick={props.onClick}
            />
        </props.componentClass>
    );
};

PasswordSymbol.propTypes = propTypes;

PasswordSymbol.defaultProps = defaultProps;

export default PasswordSymbol;
